import React, { FC, useEffect } from 'react';

import { IconButton } from '@pp/core/src/components/controls/iconButton/IconButton';
import { Icon } from '@pp/core/src/components/icons/icon';
import { Icons } from '@pp/core/src/components/icons/iconNames';
import { NavBurger } from '@pp/core/src/components/nav/navBurger/NavBurger';
import { NavPages } from '@pp/core/src/components/nav/navPages/NavPagesConnected';
import { PromotionSelector } from '@pp/core/src/components/promotionsV2/PromotionSelector';
import { useGameConfig } from '@pp/core/src/config/GameConfigProvider';
import { useMedia } from '@pp/core/src/hooks/useMedia';
import { CoreSessionStorage } from '@pp/core/src/storage/session/CoreSessionStorage';
import { useCoreDispatch } from '@pp/core/src/store/CoreStore';
import { useHeaderSlice } from '@pp/core/src/store/slices/header/selectors';
import { headerActions } from '@pp/core/src/store/slices/header/slice';
import { settingsActions } from '@pp/core/src/store/slices/settings/slice';
import { useIsLandscape } from '@pp/core/src/styles/hooks/media';
import { useModifiers } from '@pp/core/src/styles/hooks/useModifiers';
import { isCurrentBrowserIOS } from '@pp/core/src/utils/browsers';

import { useGameDispatch } from '../../../../store/GameStore';
import { highflyerGameStateActions } from '../../../../store/slices/highflyerGame/slice';
import { AnimationConnected } from '../../../highFlyerAnimation/AnimationConnected';
import { QuickGuideCellConnected } from '../../../quickGuideCell/QuickGuideCellConnected';
import { MobileCashedAndTotalBets } from '../../../tableSheet/mobileCashedAndTotalBets/MobileCashedAndTotalBets';

import styles from './VideoCellConnected.module.css';

export const VideoCellConnected: FC = () => {
  const isLandScape = useIsLandscape();
  const gameDispatch = useGameDispatch();
  const coreDispatch = useCoreDispatch();
  const { navControls } = useGameConfig();
  const navOpen = useHeaderSlice.getNavOpen();
  const isHeightLessThen320 = useMedia('(height < 320px)');
  const isWidthLessThen320 = useMedia('(width <= 320px)');
  const isWide = useMedia('(min-width:1024px) and (min-height: 500px)');
  const promoMods = useModifiers(styles, 'promoButton', { desktop: isWide, mobile: !isWide }, { withBaseClass: true });

  useEffect(() => {
    gameDispatch(settingsActions.setNoVolumeControl(isCurrentBrowserIOS));
    if (isCurrentBrowserIOS) {
      gameDispatch(settingsActions.setAllVolumes(0));
    }
  }, [gameDispatch]);

  const handleNavDrawerClose = (): void => {
    if (navOpen) {
      CoreSessionStorage.setIsChatClosed(true);
      coreDispatch(highflyerGameStateActions.setChatClosed(true));
      coreDispatch(headerActions.setBetLimitsOpen(false));
    }
    if (navOpen) {
      coreDispatch(headerActions.setNavRoute([]));
    } else {
      coreDispatch(headerActions.pushNavRoute(NavPages.HOME));
    }
  };

  return (
    <div className={styles.videoCellContainer}>
      {!isWide && (
        <>
          <div className={styles.menuButton}>
            <NavBurger
              isSmall={isHeightLessThen320 || isWidthLessThen320}
              isLarge
              onClick={handleNavDrawerClose}
              navControls={navControls}
              navControlsCondition
            />
          </div>
          <div className={styles.statsButton}>
            <IconButton
              large
              small={isHeightLessThen320 || isWidthLessThen320}
              ghost
              onClick={() => gameDispatch(highflyerGameStateActions.setToggleStats(true))}
            >
              <Icon icon={Icons.Statistics} color="white" />
            </IconButton>
          </div>
        </>
      )}
      {isLandScape && <MobileCashedAndTotalBets />}
      <div className={promoMods}>
        <PromotionSelector drawBasedOn={document.getElementById('root')} />
      </div>
      <AnimationConnected />
      <QuickGuideCellConnected />
    </div>
  );
};
